import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const links = [
  { label: "Work", href: "#work" },
  { label: "Films", href: "/films", route: true },
  { label: "About", href: "#about" },
  { label: "Crew", href: "#team" },
  { label: "Contact", href: "#contact" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLink = (e, href, kind) => {
    e.preventDefault();
    setMenuOpen(false);
    if (kind === "route") {
      navigate(href);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (href === "#top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-md border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14 flex items-center justify-between h-16 sm:h-20">
        <a
          href="#top"
          onClick={(e) => handleLink(e, "#top", "anchor")}
          data-testid="nav-logo"
          className="flex items-center"
          aria-label="Momenta Studios"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_momenta-works/artifacts/rx6m3rj4_MOMENTA%20STUDIOS%20WHITE.png"
            alt="Momenta Studios"
            className="h-9 sm:h-10 w-auto object-contain select-none"
            draggable={false}
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleLink(e, l.href, l.route ? "route" : "anchor")}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[11px] tracking-[0.3em] uppercase text-white/70 hover:text-white link-underline transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={(e) => handleLink(e, "#contact", false)}
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center text-[11px] tracking-[0.3em] uppercase text-black bg-white px-5 py-3 hover:bg-white/90 transition-colors"
        >
          Start a Project
        </a>

        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-white text-[11px] tracking-[0.3em] uppercase"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {menuOpen ? "Close" : "Menu"}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-lg border-t border-white/10">
          <nav className="flex flex-col px-6 py-8 gap-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleLink(e, l.href, l.route ? "route" : "anchor")}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-serif text-3xl text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navigation;
